export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;

export const STORAGE_PREFIX = 'dp:v2:';
